<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Master Data</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Update Master Data</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">

        <div id="masterData" v-if="isMaster">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Tag Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Tag Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.parentGroup')">
            <label>Parent Group</label>
            <md-input v-model="dataForm.parentGroup"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.parentTagId')">
            <label>Parent Tag Id</label>
            <md-input v-model="dataForm.parentTagId"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="carrierData" v-if="isCarrier">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Carrier Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Carrier Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.scacode')">
            <label>SCACODE</label>
            <md-input v-model="dataForm.scacode"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="LocationData" v-if="isLocation">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Location Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Location Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.street')">
            <label>Street</label>
            <md-input v-model="dataForm.street"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.city')">
            <label>City</label>
            <md-input v-model="dataForm.city"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.state')">
            <label>State</label>
            <md-input v-model="dataForm.state"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.zip')">
            <label>Zip</label>
            <md-input v-model="dataForm.zip"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.country')">
            <label>Country</label>
            <md-input v-model="dataForm.country"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.contactPerson')">
            <label>Contact Person</label>
            <md-input v-model="dataForm.contactPerson"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.contactTel')">
            <label>Contact Tel</label>
            <md-input v-model="dataForm.contactTel"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="RouteData" v-if="isRoute">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Route Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Route Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.stage')">
            <label>Stage</label>
            <md-input v-model="dataForm.stage"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.deptPoint')">
            <label>Dep. Point</label>
            <md-input v-model="dataForm.deptPoint"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.destPoint')">
            <label>Dest. Point</label>
            <md-input v-model="dataForm.destPoint"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="ChassisData" v-if="isChassis">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Vendor Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Vendor Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

            <datepicker v-model="dataForm.validPeriod">
            <label>Valid Period</label>
            </datepicker>

          <md-field :class="getValidationClass('dataForm.saleoffice')">
            <label>Sale Office</label>
            <md-input v-model="dataForm.saleoffice"/>
          </md-field>
          </div>

        <div id="CustomerData" v-if="isCustomer">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Customer Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Customer Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="TruckData" v-if="isTruck">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Truck Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Truck Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

            <auto-complete-select
               label="Sale Office"
               :options="this.getSaleOfficeMasterData"
               v-model="dataForm.saleoffice"
            />   

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="LeaseChassisData" v-if="isLeaseChassis">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Lease Chassis Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Sale Office</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.vendor')">
            <label>Vendor</label>
            <md-input v-model="dataForm.vendor"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.equipsize')">
            <label>Equipment Size</label>
            <md-input v-model="dataForm.equipsize"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

          <div id="ChassisVendorData" v-if="isChassisVendor">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Chassis Vendor Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Chassis Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.saleoffice')">
            <label>Sale Office</label>
            <md-input disabled v-model="dataForm.saleoffice"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.chasssisVendorType')">
            <label>Vendor Type</label>
            <md-input v-model="dataForm.chassisVendorType"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

          <div id="driverCompany" v-if="isDriverCompany"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>STC_DRIVER_COMPANY</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Driver Company Id</label>
            <md-input v-model="dataForm.tagId" disabled/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Driver Company</label>

            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtScaleAddition1')">
            <label>Scale Addition</label>
            <md-input v-model="dataForm.amtScaleAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtScaleDeduction1')">
            <label>Scale Deduction</label>
            <md-input v-model="dataForm.amtScaleDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtManifestAddition1')">
            <label>Manifest Addition</label>
            <md-input v-model="dataForm.amtManifestAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtManifestDeduction1')">
            <label>Manifest Deduction</label>
            <md-input v-model="dataForm.amtManifestDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtParkingAddition1')">
            <label>Parking Addition</label>
            <md-input v-model="dataForm.amtParkingAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtParkingDeduction1')">
            <label>Parking Deduction</label>
            <md-input v-model="dataForm.amtParkingDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtInsuranceAddition1')">
            <label>Insurance Addition</label>
            <md-input v-model="dataForm.amtInsuranceAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtInsuranceDeduction1')">
            <label>Insurance Deduction</label>
            <md-input v-model="dataForm.amtInsuranceDeduction1"/>
          </md-field>


          <md-switch id="active" v-model="dataForm.active">Active</md-switch>

          </div>

        <div id="RateBillData" v-if="isRateBill">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Rate Type</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Description</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.measureUnit')">
            <label>Measure Unit</label>
            <md-input v-model="dataForm.measureUnit"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.category')">
            <label>Category</label>
            <md-input v-model="dataForm.category"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.cntrType')">
            <label>Container Type</label>
            <md-input v-model="dataForm.cntrType"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.customer')">
            <label>Customer</label>
            <md-input v-model="dataForm.customer"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.location')">
            <label>Location</label>
            <md-input v-model="dataForm.location"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.saleoffice')">
            <label>Sales Office</label>
            <md-input v-model="dataForm.saleoffice"/>
          </md-field>


          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="RateCostData" v-if="isRateCost">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Rate Type</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Description</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.measureUnit')">
            <label>Measure Unit</label>
            <md-input v-model="dataForm.measureUnit"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.category')">
            <label>Category</label>
            <md-input v-model="dataForm.category"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.cntrType')">
            <label>Container Type</label>
            <md-input v-model="dataForm.cntrType"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.customer')">
            <label>Customer</label>
            <md-input v-model="dataForm.customer"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.location')">
            <label>Location</label>
            <md-input v-model="dataForm.location"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.saleoffice')">
            <label>Sales Office</label>
            <md-input v-model="dataForm.saleoffice"/>
          </md-field>


          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="AppMasterData" v-if="isAppMaster">

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.tagId')">
            <label>Appointment ID</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.from')">
            <label>From</label>
            <md-input v-model="dataForm.from"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.to')">
            <label>To</label>
            <md-input v-model="dataForm.to"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.appFreq')">
            <label>App Freq</label>
            <md-input v-model="dataForm.appFreq"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.additionLoad')">
            <label>Addition Load</label>
            <md-input v-model="dataForm.additionLoad"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.transYard')">
            <label>Transloading Yard</label>
            <md-input v-model="dataForm.transYard"/>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.recWindow')">
            <label>Receiving Window</label>
            <md-input v-model="dataForm.recWindow"/>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.recWindowDesc')">
            <label>Receiving Window Desc.</label>
            <md-input v-model="dataForm.recWindowDesc"/>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.dockType')">
            <label>Dock Type</label>
            <md-input v-model="dataForm.dockType"/>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.weekDay')">
            <label>Week Day</label>
            <md-input v-model="dataForm.weekDay"/>
          </md-field>

          <md-field v-if="getPermission.settings.edit" :class="getValidationClass('dataForm.weekDayDesc')">
            <label>Week Day Desc.</label>
            <md-input v-model="dataForm.weekDayDesc"/>
          </md-field>

          </div>



        <div id="YGMasterData" v-if="isYGMaster">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>YG Code</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">YG Code is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Transloading Yard</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.defaultUse')">
            <label>Default Use</label>
            <md-input v-model="dataForm.defaultUse"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.recWindow')">
            <label>Receiving Window</label>
            <md-input v-model="dataForm.recWindow"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.weight')">
            <label>Weight</label>
            <md-input v-model="dataForm.weight"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.weightUnit')">
            <label>Weight Unit</label>
            <md-input v-model="dataForm.weightUnit"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="ScaleMasterData" v-if="isScaleMaster">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Scale Code</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Scale Code is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Transloading Yard</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.defaultUse')">
            <label>Default Use</label>
            <md-input v-model="dataForm.defaultUse"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.recWindow')">
            <label>Receiving Window</label>
            <md-input v-model="dataForm.recWindow"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.warnToleranceTime')">
            <label>Warn Tolerance Time</label>
            <md-input v-model="dataForm.warnToleranceTime"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.errToleranceTime')">
            <label>Error Tolerance Time</label>
            <md-input v-model="dataForm.errToleranceTime"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="UpgradeMasterData" v-if="isUpgradeMaster">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Upgrade Code</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Upgrade Code is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Code Name</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.grade')">
            <label>Grade</label>
            <md-input v-model="dataForm.grade"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.gradeUpgrade')">
            <label>Grade Upgrade to</label>
            <md-input v-model="dataForm.gradeUpgrade"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

        <div id="WeightControlData" v-if="isWeightControl">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Weight Code</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Weight Code is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Code Name</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.diffTolerance')">
            <label>Diff Tolerance</label>
            <md-input v-model="dataForm.diffTolerance"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>

          <div id="AllowRecWindowData" v-if="isAllowReceiveWindow">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Id</label>
            <md-input v-model="dataForm.tagId" :disabled="mode === 'update'"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Location</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <!--
          <md-field :class="getValidationClass('dataForm.location')">
            <label>Location/Office</label>
            <md-input v-model="dataForm.location"/>
          </md-field>
          -->

          <auto-complete-master-data-select
                                                group="OFFICE_IP"
                                                label="Location/Office"
                                                displayType="idOnly"
                                                :init-value="dataForm.location"
                                                :watchValueId="dataForm.location"
                                                :on-item-changed="handleLocationChanged"
                                                >
          </auto-complete-master-data-select>

          <!--
          <md-field :class="getValidationClass('dataForm.recWindow')">
            <label>Receive Window</label>
            <md-input v-model="dataForm.recWindow"/>
          </md-field>
          -->
          <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="dataForm.recWindow"
                                                :watchValueId="dataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
          </auto-complete-master-data-select>


          <md-switch v-model="dataForm.active">Active</md-switch>
          </div>


          <calling-api type="bar" path="/api/w/masterData/update">

            <md-dialog-actions>
              <md-button class="md-primary" @click="closeDialog();showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
  import DatePicker from './DatePicker.vue';
  import moment from 'moment';

  const getInitialDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    parentGroup: null,
    parentTagId: null,
    active: true,
    scacode: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    contactPerson: null,
    contactTel: null,
    stage: null,
    deptPoint: null,
    destPoint: null,
    saleoffice: null,
    vendor: null,
    validPeriod: null,
    equipsize: null,
    measureUnit: null,
    category: null,
    cntrType: null,
    customer: null,
    location: null,
    recWindow: null,
    additionLoad: null,
    appFreq: null,
    dockType: null,
    recWindowDesc: null,
    from: null,
    to: null,
    transYard: null,
    weekDay: null,
    weekDayDesc: null,
    defaultUse: null,
    weight: null,
    weightUnit: null,
    grade: null,
    gradeUpgrade: null,
    diffTolerance: null,
    warnToleranceTime: null,
    errToleranceTime: null,
    chassisVendorType: null
  });

  const getCarrierDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    scacode: null,
  });

  const getLocationDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    contactPerson: null,
    contactTel: null,
  });

  const getRouteDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    stage: null,
    deptPoint: null,
    destPoint: null,
  });

  const getChassisDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    validPeriod: null,
    saleoffice: null,
    active: true,
  });

  const getCustomerDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
  });

  const getTruckDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    saleoffice: null,
  });

  const getLeasechassisDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    vendor: null,
    equipsize: null,
  });


  const getDriverCompanyDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    amtScaleAddition1: null,
    amtScaleDeduction1: null,
    amtManifestAddition1: null,
    amtManifestDeduction1: null,
    amtParkingAddition1: null,
    amtParkingDeduction1: null,
    amtInsuranceAddition1: null,
    amtInsuranceDeduction1: null
  });

  const getChassisVendorDataForm = () =>
  ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    chassisVendorType: null,
    saleoffice: null,
  });

  const getRateBillDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   measureUnit: null,
   category: null,
   cntrType: null,
   customer: null,
   location: null,
   saleoffice: null,
  });

  const getRateCostDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   measureUnit: null,
   category: null,
   cntrType: null,
   customer: null,
   location: null,
   saleoffice: null,
  });

  const getAppMasterDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   recWindow: null,
   additionLoad: null,
   appFreq: null,
   dockType: null,
   from: null,
   recWindowDesc: null,
   to: null,
   transYard: null,
   weekDay: null,
   weekDayDesc: null,
  });

  const getYGMasterDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   defaultUse: null,
   recWindow: null,
   weight: null,
   weightUnit: null,
  });

  const getScaleMasterDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   defaultUse: null,
   recWindow: null,
   warnToleranceTime: null,
   errToleranceTime: null,
  });

  const getUpgradeMasterDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   grade: null,
   gradeUpgrade: null,
  });

  const getWeightControlDataForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   diffTolerance: null,
  });

  const getAllowReceiveWindowForm = () =>
  ({
   group: null,
   tagId: null,
   tagName: null,
   active: true,
   recWindow: null,
   location: null, 
  });



  export default {
  components: { DatePicker },
    mixins: [validationMixin],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      stores: [],
      dispatchers: [],
      dataForm: getInitialDataForm(),
      isMaster: true,
      isCarrier: false,
      isLocation: false,
      isRoute: false,
      isChassis: false,
      isCustomer: false,
      isTruck: false,
      isLeaseChassis: false,

      isDriverCompany: false,

      isChassisVendor: false,
      isRateBill: false,
      isRateCost: false,
      isAppMaster: false,
      isYGMaster: false,
      isScaleMaster: false,
      isUpgradeMaster: false,
      isWeightControl: false,
      isAllowReceiveWindow: false,
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getSaleOfficeMasterData',
        'getSaleOfficeIdByName',
        'getPermission'
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        group: {
          required,
        },
        tagId: {
          required,
        },
        tagName: {
          required,
        },
      },
    },
    methods: {
      openDialog(existingData) {
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();
        console.log('type',existingData.group);
        console.log(`openDialog`, existingData);
        if (existingData && this.mode === 'update') {
          if (existingData.group === 'STC_CARRIER')
          {
             this.isMaster = false;
             this.isCarrier = true;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getCarrierDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "STC_CARRIER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.active = existingData.active;
             this.dataForm.scacode = existingData.scacode;
          }
          else if (existingData.group === "STC_TERMINAL")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = true;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getLocationDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "STC_TERMINAL";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.active = existingData.active;
             this.dataForm.street = existingData.street;
             this.dataForm.city = existingData.city;
             this.dataForm.state = existingData.state;
             this.dataForm.zip = existingData.zip;
             this.dataForm.country = existingData.country;
             this.dataForm.contactPerson = existingData.contactperson;
             this.dataForm.contactTel = existingData.contacttel;
          }
          else if (existingData.group === "GST_ROUTE")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = true;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getRouteDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_ROUTE";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.active = existingData.active;
             this.dataForm.stage = existingData.stage;
             this.dataForm.deptPoint = existingData.deptPoint;
             this.dataForm.destPoint = existingData.destPoint;
          }
          else if (existingData.group === "GST_CHASSIS")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = true;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getChassisDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_CHASSIS";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             console.log(existingData.validPeriod)
             this.dataForm.validPeriod = moment(String(existingData.validPeriod)).format('MM/DD/YYYY');
             console.log(this.dataForm.validPeriod)
             this.dataForm.saleoffice = existingData.saleoffice;
          }
          else if (existingData.group === "GST_CUSTOMER")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = true;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getCustomerDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_CUSTOMER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "GST_TRUCK")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = true;
             this.isLeaseChassis = false;

             this.isDriverCompany = false;

             this.isChassisVendor = false;
             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getTruckDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_TRUCK";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.saleoffice = existingData.saleoffice;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "GST_LEASECHASSIS")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = true;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getLeasechassisDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_LEASECHASSIS";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.vendor = existingData.vendor;
             this.dataForm.equipsize = existingData.equipsize;
             this.dataForm.active = existingData.active;
          }

          else if (existingData.group === "STC_DRIVER_COMPANY")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isDriverCompany = true;
             this.isChassisVendor = false;
             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getDriverCompanyDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "STC_DRIVER_COMPANY";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.amtScaleAddition1 = existingData.amtScaleAddition1;
             this.dataForm.amtScaleDeduction1 = existingData.amtScaleDeduction1;
             this.dataForm.amtManifestAddition1 = existingData.amtManifestAddition1;
             this.dataForm.amtManifestDeduction1 = existingData.amtManifestDeduction1;
             this.dataForm.amtParkingAddition1 = existingData.amtParkingAddition1;
             this.dataForm.amtParkingDeduction1 = existingData.amtParkingDeduction1;
             this.dataForm.amtInsuranceAddition1 = existingData.amtInsuranceAddition1;
             this.dataForm.amtInsuranceDeduction1 = existingData.amtInsuranceDeduction1;
             this.dataForm.active = existingData.active;
          }

          else if (existingData.group === "STC_CHASSIS_VENDOR")
          {
            this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = true;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getChassisVendorDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "STC_CHASSIS_VENDOR";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.chassisVendorType = existingData.chassisVendorType;
             this.dataForm.saleoffice = existingData.saleoffice;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "GST_RATE_BIILLING")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = true;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getRateBillDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_RATE_BILLING";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.measureUnit = existingData.measureUnit;
             this.dataForm.category = existingData.category;
             this.dataForm.cntrType = existingData.cntrType;
             this.dataForm.customer = existingData.customer;
             this.dataForm.location = existingData.location;
             this.dataForm.saleoffice = existingData.saleoffice;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "GST_RATE_COST")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = true;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getRateCostDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "GST_RATE_COST";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.measureUnit = existingData.measureUnit;
             this.dataForm.category = existingData.category;
             this.dataForm.cntrType = existingData.cntrType;
             this.dataForm.customer = existingData.customer;
             this.dataForm.location = existingData.location;
             this.dataForm.saleoffice = existingData.saleoffice;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "APP_MASTER")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = true;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getAppMasterDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "APP_MASTER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.recWindow = existingData.recWindow;
             this.dataForm.additionLoad = existingData.additionLoad;
             this.dataForm.appFreq = existingData.appFreq;
             this.dataForm.dockType = existingData.dockType;
             this.dataForm.from = existingData.from;
             this.dataForm.recWindowDesc = existingData.recWindowDesc;
             this.dataForm.to = existingData.to;
             this.dataForm.transYard = existingData.transYard;
             this.dataForm.weekDay = existingData.weekDay;
             this.dataForm.weekDayDesc = existingData.weekDayDesc;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "YG_MASTER")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = true;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getYGMasterDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "YG_MASTER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.defaultUse = existingData.defaultUse;
             this.dataForm.recWindow = existingData.recWindow;
             this.dataForm.weight = existingData.weight;
             this.dataForm.weightUnit = existingData.weightUnit;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "SCALE_MASTER")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = true;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getScaleMasterDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "SCALE_MASTER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.defaultUse = existingData.defaultUse;
             this.dataForm.recWindow = existingData.recWindow;
             this.dataForm.warnToleranceTime = existingData.warnToleranceTime;
             this.dataForm.errToleranceTime = existingData.errToleranceTime;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "UPGRADE_MASTER")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = true;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getUpgradeMasterDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "UPGRADE_MASTER";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.grade = existingData.grade;
             this.dataForm.gradeUpgrade = existingData.gradeUpgrade;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "WEIGHT_CONTROL")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = true;
             this.isAllowReceiveWindow = false;
             this.dataForm = getWeightControlDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "WEIGHT_CONTROL";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.diffTolerance = existingData.diffTolerance;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "OUTBOUND_GRADE")
          {
             this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = true;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = false;
             this.dataForm = getUpgradeMasterDataForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = "OUTBOUND_GRADE";
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.grade = existingData.tagId;
             this.dataForm.active = existingData.active;
          }
          else if (existingData.group === "ALLOW_REC_WIN")
          {
            this.isMaster = false;
             this.isCarrier = false;
             this.isLocation = false;
             this.isRoute = false;
             this.isChassis = false;
             this.isCustomer = false;
             this.isTruck = false;
             this.isLeaseChassis = false;
             this.isChassisVendor = false;

             this.isDriverCompany = false;

             this.isRateBill = false;
             this.isRateCost = false;
             this.isAppMaster = false;
             this.isYGMaster = false;
             this.isScaleMaster = false;
             this.isUpgradeMaster = false;
             this.isWeightControl = false;
             this.isAllowReceiveWindow = true;
             this.dataForm = getAllowReceiveWindowForm();
             this.$v.dataForm.$reset();
             this.dataForm.group = existingData.group;
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.active = existingData.active;
             this.dataForm.recWindow = existingData.recWindow;
             this.dataForm.location = existingData.location;
          }
          else
          {
             this.dataForm.group = existingData.group;
             this.dataForm.tagId = existingData.tagId;
             this.dataForm.tagName = existingData.tagName;
             this.dataForm.parentGroup = existingData.parentGroup;
             this.dataForm.parentTagId = existingData.parentTagId;
             this.dataForm.active = existingData.active;
          }
        }

        this.showDialog = true;
      },
      handleWindowsChanged(id) {
        this.dataForm.recWindow = id;
      },
      handleLocationChanged(id) {
        this.dataForm.location = id;
      },
      closeDialog(){
        this.isMaster = true,
        this.isCarrier = false,
        this.isLocation = false,
        this.isRoute = false,
        this.isChassis = false,
        this.isCustomer = false,
        this.isTruck = false,
        this.isLeaseChassis = false,
        this.isChassisVendor = false;
        this.isRateBill = false,
        this.isDriverCompany = false;
        this.isRateCost = false
        this.isAppMaster = false;
        this.isYGMaster = false;
        this.isScaleMaster = false;
        this.isUpgradeMaster = false;
        this.isWeightControl = false;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();

        if (this.dataForm.amtScaleAddition1 && this.dataForm.amtScaleAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtScaleAddition1))
           {
               alert("Scale Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtScaleDeduction1 && this.dataForm.amtScaleDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtScaleDeduction1))
           {
               alert("Scale Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtManifestAddition1 && this.dataForm.amtManifestAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtManifestAddition1))
           {
               alert("Manifest Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtManifestDeduction1 && this.dataForm.amtManifestDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtManifestDeduction1))
           {
               alert("Manifest Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtParkingAddition1 && this.dataForm.amtParkingAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtParkingAddition1))
           {
               alert("Parking Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtParkingDeduction1 && this.dataForm.amtParkingDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtParkingDeduction1))
           {
               alert("Parking Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtInsuranceAddition1 && this.dataForm.amtInsuranceAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtInsuranceAddition1))
           {
               alert("Insurance Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtInsuranceDeduction1 && this.dataForm.amtInsuranceDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtInsuranceDeduction1))
           {
               alert("Insurance Deduction amount needs to be numeric or demical!");
               return;
           }

        if (this.$v.dataForm.$invalid) {
          console.log("data form is invalid");
          return;
        }


        //this.$store
        //  .dispatch(
        //    "updateMasterDataGroup",
        //    this.dataForm.group,
        //  ).then( () => {console.log("save Master Data Group" + this.dataForm.group);});

      
        this.$store
          .dispatch(
            "updateMasterData",
            this.dataForm,
          )
          .then(() => {
            //console.log("save master data info");
            this.showDialog = false;
            this.onUpdate();
          });
      },
    },
  };
</script>
